import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css'; // Import css
import { toast } from 'react-toastify';
import api from '../../services/api';
const VerifyRedeemPage = () => {
  const { couponId } = useParams();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleRedeem = async () => {
    setLoading(true);
    try {
      const response = await api.post(`/restaurants/redeem/${couponId}`);
      if (response.status === 200) {
        toast.success('Coupon redeemed successfully!');
        navigate(-1); // Go back to the previous page
      } else {
        toast.error('Failed to redeem coupon.');

        setError('Failed to redeem coupon.');
      }
    } catch (err) {
      toast.error('Failed to redeem coupon.');

      setError(err.response?.data?.message || 'Error redeeming coupon.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    navigate(-1); // Go back if they choose not to redeem
  };

  return (
    <>
      {showModal && (
        <div className='fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full'>
          <div className='relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-md bg-white'>
            <div className='mt-3 text-center'>
              <h3 className='text-lg leading-6 font-medium text-gray-900'>
                Confirm Redemption
              </h3>
              <div className='mt-2 px-7 py-3'>
                <p className='text-sm text-gray-500'>
                  Once this coupon is redeemed, it cannot be reused. Do you want
                  to continue?
                </p>
              </div>
              <div className='items-center px-4 py-3'>
                <button
                  onClick={handleRedeem}
                  className={`inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                    loading && 'opacity-50 cursor-not-allowed'
                  }`}
                  disabled={loading}
                >
                  {loading ? 'Redeeming...' : 'Confirm'}
                </button>
                <button
                  onClick={handleClose}
                  className='mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {error && (
        <div className='bg-red-500 text-white p-3 rounded mx-auto w-96 text-center'>
          {error}
        </div>
      )}
    </>
  );
};

export default VerifyRedeemPage;

// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const VerifyRedeemPage = () => {
//   const { couponId } = useParams();
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   useEffect(() => {
//     // Optionally, fetch coupon details if needed
//     setLoading(false);
//   }, []);

//   const handleRedeem = async () => {
//     setLoading(true);
//     try {
//       const response = await axios.post(`/api/restaurants/redeem/${couponId}`);
//       if (response.status === 200) {
//         alert('Coupon redeemed successfully!');
//         navigate('/coupon-details'); // Redirect to a success or coupon page
//       } else {
//         setError('Failed to redeem coupon.');
//       }
//     } catch (error) {
//       setError('Error redeeming coupon.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div>Error: {error}</div>;

//   return (
//     <div>
//       <h1>Verify Coupon Redemption</h1>
//       <button onClick={handleRedeem}>Redeem Coupon</button>
//     </div>
//   );
// };

// export default VerifyRedeemPage;
